export default __webpack_public_path__ + "static/media/crown.aeb19e1e.svg";